import { Component } from '@angular/core';
import { DatePicker } from '@ionic-native/date-picker';
import { NavController, ModalController, ToastController, LoadingController,NavParams, AlertController, ActionSheetController, Platform } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { LocationPage, ConditionPage, ClassificationPage, DepartmentPage, DetailImagePage, ProjectPage, SelectPage } from '@pages/asset';

import { Item, Api, Tracking, Master, Assignment  } from '@providers/asset/index';
import { TrackingFasker, TrackingAsset, UserMyRadiant as User } from '@providers/index';

declare var cordova:any;

@Component({
  selector   : 'page-form_item',
  templateUrl: 'index.html'
})
export class FormItemPage {

  item = {
    id                       : '',
    scm_asset_id             : '',
    asset_name               : '',
    asset_classification_id  : '',
    asset_classification_code: '',
    asset_classification_name: '',
    asset_location_id        : '',
    asset_location_name      : '',
    asset_old_code           : '',
    asset_old_code2          : '',
    asset_temp_code          : '',
    asset_new_code           : '',
    asset_new_code2          : '',
    asset_condition_id       : '',
    asset_condition_name     : '',
    location                 : '',
    status_location          : '',
    estimated_value          : '',
    brand                    : '',
    brand_type               : '',
    no_seri                  : '',
    no_po                    : '',
    company_id               : '',
    company_name             : '',
    department_id            : '',
    department_name          : '',
    project_code             : '',
    project_title            : '',
    user_id                  : '',
    asset_user_name          : '',
    user_code                : '',
    user_code_dept           : '',
    user_dept_name           : '',
    pj_id                    : '',
    pj_nik                   : '',
    pj_name                  : '',
    last_opname              : '',
    acquisition_year         : '',
    calibration_expired      : null,
    item_amount              : 1,
    location_path_id         : '',
    related_to               : '',
    flag_perbaikan           : 0,
    flag_temuan              : 0,
    flag_modify              : 0,
    flag_penghapusan         : 0,
    flag_kalibrasi           : 0,
    notes                    : '',
    witness_by               : '',
    verify_by_dept           : 0,
    verify_by_department_name: '',
    assignment_id            : 0,
    item_validated           : 0
  };

  form_perbaikan = {
    id                : '',
    type_perbaikan    : '',
    vendor_id         : '',
    vendor_name       : '',
    tanggal_perbaikan : '',
    keterangan        : ''
  }

  id_perbaikan    = 0;
  last_perbaikan  = {}
  f_perbaikan_old = false;
  f_perbaikan     = false;
  f_temuan        = false;
  f_modify        = false;
  f_penghapusan   = false;
  f_validated     = false;
  f_kalibrasi     = false;

  images      :any = [];
  base_qr     :any = '';
  url_img     :any = 'x';
  base_url         = '';
  list_path   :any = [];
  qr_code_data:any = '';
  listCompany :any = [];

  assign        = 0;
  assignment_id = 0;
  assign_type   = '';

  user_data : any;

  user_asset = '';
  asset_fasker_type = [
    {'user_asset' : 'dept', 'asset_fasker_name' : 'Department'},
    {'user_asset' : 'user', 'asset_fasker_name' : 'Karyawan'},
  ]

  form_fasker_id = 0;

  item_tracking :any='';

  tracking_active = {
    id : 0
  }

  data_src = '';
  tracking_act = '';

  constructor(
    public api           : Api,
    public itemApi       : Item,
    public trackingApi   : Tracking,
    public faskerApi     : TrackingFasker,
    public masterApi     : Master,
    public userApi       : User,
    public navCtrl       : NavController,
    public modalCtrl     : ModalController,
    public barcodeScanner: BarcodeScanner,
    public camera        : Camera,
    public toastCtrl     : ToastController,
    public loadingCtrl   : LoadingController, 
    private alertCtrl    : AlertController,
    public actSheetCtrl  : ActionSheetController,  
    public platform      : Platform, 
    navParams            : NavParams,
    public assignmentApi : Assignment,
    private datePicker   : DatePicker
  ) {

    this.base_url = this.api.url;
    this.url_img  = this.api.url+'/client/uploads/';
    this.user_data = this.userApi.data;
    console.log("user data form => ", this.user_data);

    this.tracking_active = navParams.get('tracking_active');
    this.data_src        = navParams.get('src');
    this.tracking_act    = navParams.get('tracking_act');
    console.log("data_src at form => ", this.data_src);
    console.log("tracking_act => ", this.tracking_act)

    if(navParams.get('id')!=undefined && navParams.get('id')!= ''){
      this.item.id = navParams.get('id');
      this.getItemByID(this.item.id);
      this.getImagesByID();
    }

    this.getCompany();

    this.form_fasker_id = navParams.get('form_id');
    if(this.form_fasker_id == 7){
      this.user_asset = 'user'
    }else if(this.form_fasker_id == 9){
      this.user_asset = 'dept'
    }

    if(this.item.id != ''){
      this.getItemTracking();
    }else{
      if(this.form_fasker_id == 7){
        this.item.user_code       = this.user_data.user_nik;
        this.item.asset_user_name = this.user_data.Nama_Karyawan;
      }else if(this.form_fasker_id == 9){
        this.item.pj_id   = this.user_data.employee_id;
        this.item.pj_name = this.user_data.Nama_Karyawan;
        this.item.pj_nik  = this.user_data.user_nik;
        this.item.user_code_dept = this.user_data.department_id;
        this.item.user_dept_name = this.user_data.department_name;
      }
      console.log(
        this.item
      )
    }
  }

  presentToast(msg){
    this.toastCtrl.create({
      message  : msg,
      duration : 3000,
      position : 'top'
    }).present();
  }

  pilihCondition() {
    let myModal = this.modalCtrl.create(ConditionPage, { pilih: 1 });
    myModal.onDidDismiss(data => {
      if(data.item){
        this.item.asset_condition_name = data.item.name;
        this.item.asset_condition_id   = data.item.id;
      }
    });
    myModal.present();
  }

  getCompany(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { };
    this.masterApi.getCompany(params).subscribe((resp:any) => {
      this.listCompany = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }
  
  pilihDepartment() {
    let myModal = this.modalCtrl.create(DepartmentPage, { pilih: 1 });
    myModal.onDidDismiss(data => {
      if(data.item){
        this.item.department_name = data.item.department_name;
        this.item.department_id   = data.item.department_id;
      }
    });
    myModal.present();
  }

  pilihProject(){
    if(this.assignment_id==0 || this.assign_type!='project'){
      let myModal = this.modalCtrl.create(ProjectPage, { pilih:1 });
      myModal.onDidDismiss(data => {
        if(data.item){
          this.item.project_title = data.item.title;
          this.item.project_code  = data.item.project_code;
        }
      });
      myModal.present();
    }else{
      this.presentToast("Yout can't change project");
    }
  }

  pilihLocation() {
    if(this.assignment_id==0 || this.assign_type!='location'){
      let myModal = this.modalCtrl.create(LocationPage, { pilih: 1 });
      myModal.onDidDismiss(data => {
        if(data.item){
          this.item.asset_location_name = data.item.location_name;
          this.item.asset_location_id   = data.item.id;
          this.getPath(data.item.location_path_id);
        }
      });
      myModal.present();
    }else{
      this.presentToast("You can't change location");
    }
  }

  pilihClassification() {
    let myModal = this.modalCtrl.create(ClassificationPage, { pilih: 1 });
    myModal.onDidDismiss(data => {
      if(data.item){
        this.item.asset_classification_name = data.item.classification_name;
        this.item.asset_classification_id   = data.item.id;
        this.item.asset_classification_code = data.item.classification_code;
      }
    });
    myModal.present();
  }

  scan(field){
      this.barcodeScanner.scan().then(barcodeData => {
        console.log('Barcode data', barcodeData);
        this.item[field]= barcodeData.text;
       }).catch(err => {
           console.log('Error', err);
       });
    }
  
  ketik(idx){
    let msg = "";
    msg = "Nomor Asset atau Serial Number";
    let alert = this.alertCtrl.create({
      //title: 'Konfirmasi',
      subTitle: msg,
      inputs: [
        {
          name: 'code',
          placeholder: 'Serial Number'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Done',
          handler: data => {
            this.item[idx] = data.code;
          }
        }
      ]
    });
    alert.present();
  }
  
  getItemByID(id){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {id: id};
    
    let get: any;
    console.log("data source => ", this.data_src);
    if(this.data_src == "old"){
      get = this.itemApi.get_detail(params);
    }else{
      get = this.faskerApi.getDetail(params);
    }

    get.subscribe((resp:any) => {
      if(resp.data.length>0){
        this.item = resp.data[0];
        this.getPath(this.item.location_path_id);
        this.qr_code_data = JSON.stringify(this.item);
      }

      console.log('user asset => ', this.user_asset);
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  getItemTracking(){
    let params = {
      asset_id : '',
      asset_id_old : ''
    }
    params.asset_id = this.item.id;
    if(this.data_src == 'old'){
      params.asset_id_old = this.item.id
    }
    this.faskerApi.getTrackedItem(params).subscribe((resp:any) => {
      if(resp.data != ''){
        this.item_tracking = resp.data[0];
      }
      console.log('tracking item => ', this.item_tracking);
    });  
  }

  getImagesByID(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params : any =  {
      asset_id: this.item.id
    };
    let get : any;
      get = this.faskerApi.getImages(params);
      get.subscribe((resp:any) => {
        if(resp.data.length>0){
          this.images = resp.data;
        }
        loading.dismiss();
      }, (err) => {
        loading.dismiss();
      });
  }

  addPicture(camera=1){
    const actionSheet = this.actSheetCtrl.create({
      title   : 'Image Category',
      buttons : [
        {
          text    : 'Foto Serial Number',
          // icon    : 'barcode',
          handler : () => {
            this.takePicture(camera, 'sn');
          } 
        },
        {
          text    : 'Foto Fisik',
          // icon    : 'bluetooth',
          // cssClass: 'BluetoothIcon',
          handler : () => {
            this.takePicture(camera, 'fi');
          } 
        }
      ]
    });
    actionSheet.present();
  }

  takePicture(camera=1, type){
    const options: CameraOptions = {
      quality        : 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth    : 1024,
      sourceType     : camera
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image, type);
    }, (err) => {
     // Handle error
    });
  }


  viewImage(rec) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.url_img+rec.generated_name,
      detail: rec,
      edit : true,
      assign : this.assign
    });
    profileModal.present();
    console.log("Image params => ", rec);
  }
  
  
  resetAdd(){
    this.item.id             ='';
    this.item.asset_name     ='';
    this.item.asset_old_code ='';
    this.item.asset_temp_code='';
    this.item.asset_new_code ='';
    this.item.estimated_value='';
  }

  simpan(){
    let confirm = this.alertCtrl.create({
      title    : 'Konfirmasi',
      subTitle : 'Anda yakin data yang anda inputkan sesuai ?',
      buttons  : [
        {
          text    : 'Tidak',
          handler : () => {
            console.log("No Clicked")
          }
        },
        {
          text    : 'Ya',
          handler : () => {
            console.log("Yes clicked");
            this.simpanAct();
          }
        }
      ]
    });
    confirm.present();
  }

  simpanAct(){
    // if(this.item.asset_name=='' || this.item.asset_name==null){
    //   this.presentToast('Gagal simpan, Asset Name tidak boleh kosong.');
    //   return;
    // }
    // if(this.item.asset_classification_id=='' || this.item.asset_classification_id=='0' || this.item.asset_classification_id==null){
    //   this.presentToast('Gagal simpan, Klasifikasi tidak boleh kosong.');
    //   return;
    // }
    // if(this.item.asset_location_id=='' || this.item.asset_location_id=='0' || this.item.asset_location_id==null){
    //   this.presentToast('Gagal simpan, Lokasi tidak boleh kosong.');
    //   return;
    // }
    // if(this.item.company_id=='' || this.item.company_id==null || this.item.company_id=='0'){
    //   this.presentToast('Gagal simpan, Company tidak boleh kosong.');
    //   return;
    // }
    // if(this.item.acquisition_year==0){
    //   this.presentToast('Gagal simpan, Acquisition Year tidak boleh kosong.');
    //   return;
    // }
    // if(this.item.department_id=='' || this.item.department_id=='0' || this.item.department_id==null){
    //   this.presentToast('Gagal simpan, Dept/cabang tidak boleh kosong.');
    //   return;
    // }
    // if(this.item.flag_perbaikan==1){
    //   if(this.form_perbaikan.tanggal_perbaikan==''){
    //     this.presentToast('Lengkapi data tanggal perbaikan !');
    //     return;
    //   }
    //   if(this.form_perbaikan.type_perbaikan==''){
    //     this.presentToast('Lengkapi data type perbaikan !');
    //     return;
    //   }
    //   if(this.form_perbaikan.type_perbaikan=='Vendor' && this.form_perbaikan.vendor_id==''){
    //     this.presentToast('Lengkapi data vendor perbaikan !');
    //     return;
    //   }
    //   if(this.form_perbaikan.keterangan==''){
    //     this.presentToast('Lengkapi data keterangan perbaikan');
    //     return;
    //   }
    // }
    // if(this.item.asset_name==''){
    //   this.item.asset_name = this.item.asset_classification_name;
    // }
    // if(this.images.length < 2){
    //   this.presentToast('lengkapi gambar asset minimal 2 !');
    //   return;
    // }
    if(this.data_src == 'add' && this.item.no_seri == ''){
      this.presentToast("harap isi field asset number");
      return;
    }

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params:any = this.item;

    params.dokument_id = '';
    let dok_arr = [];
    this.images.forEach(el => {
      if(el.asset_id==undefined){
        dok_arr.push(el.dokument_id);
      }
    });
    params.dokument_id = dok_arr.join(',');
    if(this.data_src == 'old'){
      params.scm_asset_id = this.item.id;
      params.id = '';
    }
    console.log("params form send =>",params);
      this.faskerApi.saveItem(params).subscribe((resp:any) => {
        console.log("resp after add => ", resp.data);
        if(resp.success){
          let data:any = {
            id : '',
            location_id: params.location_id,
            tracking_id : this.tracking_active.id,
            asset_item_id : resp.data.id
          }
          if(this.data_src == 'old'){
            data.asset_item_id_old = resp.data.scm_asset_id
          }
          if(this.item_tracking.act == 'new'){

          }else if(this.item_tracking.act == 'scanned'){
            data.act = 'modify'
          }else if(this.item_tracking.act == 'modify'){
            data.act = 'modify'
          }else{
            if(this.tracking_act == 'scanned'){
              data.act = 'scanned'
            }else{
            // if(params.id=='' && this.data_src == 'add'){
            //   data.act = 'new';
            // }else{
                if(this.data_src == 'add'){
                  data.act = 'new'
                }else{
                  data.act = 'modify';
                }
            // }
            }
          }
          if(this.item_tracking != ''){
            data.id = this.item_tracking.id;
          }
          this.track_item(data);
        }
        // if(param == undefined || param == ''){
        //   this.item.id = resp.data.id;
        //   this.getItemTracking(resp.data.id);
        //   this.getItemByID(resp.data.id);
        //   this.getImagesByID();
        // }else{
          this.navCtrl.pop();
        // }

        console.log("resp => ", resp);
        loading.dismiss();
        this.presentToast(resp.msg);
      }, (err) => {
        loading.dismiss();
      });
    
  }

  track_item(params){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    this.faskerApi.post(params).subscribe((resp:any) => {      
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  assign_item(params){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    this.assignmentApi.saveTrackAssign(params).subscribe((resp:any) => {      
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }
  
  save_image(img, type){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {img: img};
    this.itemApi.save_image(params).subscribe((resp:any) => {
      resp.data.dokument_id=resp.data.id;
      resp.data.id='';
      this.images.push(resp.data);
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  getPath(location_path){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { location_path: location_path };
    
    this.masterApi.getLocation(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.list_path = resp.data;
      }else{
        
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  printType(){
    const actionSheet = this.actSheetCtrl.create({
      title   : 'Printer Type',
      buttons : [
        {
          text    : 'Wi-Fi',
          icon    : 'wifi',
          handler : () => {
            console.log('Print Via Wifi');
            this.getPrinters('wifi');
          } 
        },
        {
          text    : 'Bluetooth',
          icon    : 'bluetooth',
          cssClass: 'BluetoothIcon',
          handler : () => {
            console.log('Print Via Bluetooth');
            this.getPrinters('bluetooth');
          } 
        }
      ]
    });
    actionSheet.present();
  }

  getPrinters(type){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    
    let params :any = {
      t  : this.item.asset_new_code,
      t_ : this.item.asset_new_code2,
      t2 : this.item.asset_old_code2,
      s  : 0
    };

    let find : any;
    if(type=='wifi'){
      find = cordova.plugins.brotherPrinter.findNetworkPrinters;
    }else{
      find = cordova.plugins.brotherPrinter.findBluetoothPrinters;
    }
    this.masterApi.getBaseQR(params).subscribe((resp:any) => {
      var that = this;
      this.base_qr = resp.image_data_base64;
      find(function(printers){
        if(printers.length>0){
          console.log('printers found => ',printers);
          // if(printers.length==1){
          //   this.print(printers[0]);
          // }else{
            loading.dismiss();
            const printerActSheet = that.actSheetCtrl.create({
              title: 'Pilih Printer'
            });
            for (let i = 0; i < printers.length; i++) {
              var button = {
                text   : printers[i].model+' - '+printers[i].nodeName,
                icon   : 'print',
                handler: () => {
                  console.log('printer used => ',printers[i]);
                  that.print(printers[i]);
                }
              }
              printerActSheet.addButton(button);
            }
            printerActSheet.present();
          // }
        }else{
          alert('Printer Not Found !');
          loading.dismiss();
        }
      },function(err){
        console.log(err);
        loading.dismiss();
      }); 
    }, (err) => {
      console.log(err);
      loading.dismiss();
    }); 
  }

  print(printer){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let that = this;

    cordova.plugins.brotherPrinter.setPrinter(printer, function(){
      cordova.plugins.brotherPrinter.printViaSDK(that.base_qr,function(statusCode){
        console.log(statusCode);
        if(statusCode.result){
          that.presentToast(statusCode.result);
        }
        loading.dismiss();
      },function(err){
        console.log(err);
        loading.dismiss();
      });
    },function(err) {
      console.log(err);
      loading.dismiss();
    });     
  }

  pilihUser(){
    let myModal = this.modalCtrl.create(SelectPage, { pilihModal: 3, selectMod:3, assigne:0 });
    myModal.onDidDismiss(data => {
      if(data.item!=''){
        this.item.asset_user_name = data.item.user_name;
        this.item.user_code       = data.item.user_nik;
        this.item.user_dept_name  = '';
        this.item.user_code_dept  = '0';
        console.log('user_code_dept => ', this.item.user_code_dept);
      }
    });
    myModal.present();
  }
  pilihUserDept(){
    let myModal = this.modalCtrl.create(DepartmentPage, { pilih: 1 });
    myModal.onDidDismiss(data => {
      if(data.item){
        this.item.user_dept_name  = data.item.department_name;
        this.item.user_code_dept  = data.item.department_id;
        this.item.asset_user_name = '';
        this.item.user_code       = '0';
        console.log('user_code => ', this.item.user_code);
      }
    });
    myModal.present();
  }
  pilihPJ(){
    let myModal = this.modalCtrl.create(SelectPage, { pilihModal: 3, selectMod:3, assigne:0 });
    myModal.onDidDismiss(data => {
      if(data.item!=''){
        this.item.pj_name = data.item.user_name;
        this.item.pj_id   = data.item.id;
        this.item.pj_nik  = data.item.user_nik;
      }
    });
    myModal.present();
  }

  selectWitness(){
    let myModal = this.modalCtrl.create(SelectPage, { pilihModal: 3, selectMod:3, assigne:0 });
    myModal.onDidDismiss(data => {
      if(data.item!=''){
        this.item.witness_by= data.item.user_name;
      }
    });
    myModal.present();
  }

  selectVerifyDept(){
    let myModal = this.modalCtrl.create(DepartmentPage, {pilih:1, sourceDept:'ops'});
    myModal.onDidDismiss(data => {
      if(data.item!=''){
        this.item.verify_by_department_name=data.item.department_name;
        this.item.verify_by_dept=data.item.department_id;
      }
    });
    myModal.present();
  }

  selectCalibrationExpired(){
    this.datePicker.show({
      date        : new Date(),
      mode        : 'date',
      // minDate     : new Date().valueOf(),
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT
    }).then(
      date => this.item.calibration_expired = new Date(date.getTime() - 
      date.getTimezoneOffset()*60000).toISOString(),
      err  => console.log('ERROR : '+ err)
    );
  }

  pilihTanggalPerbaikan(){
    this.datePicker.show({
      date        : new Date(),
      mode        : 'date',
      // minDate: new Date().valueOf(),
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT
    }).then(
      date => this.form_perbaikan.tanggal_perbaikan = new Date(date.getTime() - 
      date.getTimezoneOffset()*60000).toISOString(),
      err  => console.log('ERROR : '+ err)
    );
  }

  pilihVendorPerbaikan(){
    let myModal = this.modalCtrl.create(SelectPage, { pilihModal: 4, selectMod:4, assigne:0 });
    myModal.onDidDismiss(data => {
      if(data.item!=''){
        this.form_perbaikan.vendor_name = data.item.vendor_name;
        this.form_perbaikan.vendor_id   = data.item.id;
      }
    });
    myModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/opname/form_item/index.ts